import React from 'react';
import { withSnackbar } from 'notistack';
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import { connect } from "react-redux";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { Alert } from "react-bootstrap";
import moment from 'moment';
import { injectIntl } from "react-intl";
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';

class ItqDocument extends BaseDocument {
    constructor(props) {
        super(props);
    }

    renderForm = () => {
        const { fields } = this.props.workflowItem;
        const editorFormConfig = {
            fields: []
        };
        if (fields.Subject.visible) {
            editorFormConfig.fields.push({ label: fields.Subject.label, dataField: 'subject' });
        }
        editorFormConfig.fields.push({ note: this.props.resources.InstructionToQuoteNote.replace('$date', moment().add(this.props.globalResources.ITQ_QUOTE_DURATION, 'days').format('L')) });
        if (fields.Description.visible) {
            editorFormConfig.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor' });
        }

        if (fields.StartDate.visible) {
            const startDateField = { label: fields.StartDate.label, dataField: 'startdate', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } };
            if (fields.CompletionDate.visible) {
                startDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.completiondate >= value), warning: 'Completion date can not be earlier than start date' }
            }
            editorFormConfig.fields.push(startDateField)
        }
        if (fields.CompletionDate.visible) {
            const completionDateField = { label: fields.CompletionDate.label, dataField: 'completiondate', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } }

            if (fields.StartDate.visible) {
                completionDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.startdate <= value), warning: 'Completion date can not be earlier than start date' }
            }

            editorFormConfig.fields.push(completionDateField);
        }
        if (fields.DelayAmount.visible) {
            editorFormConfig.fields.push({ label: fields.DelayAmount.label, dataField: 'delaydamagestotal', editorType: 'dxNumberBox' })
        }
        if (fields.DelayPaymentPeriod.visible) {
            editorFormConfig.fields.push({ label: fields.DelayPaymentPeriod.label, dataField: 'delaydamagestype', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.DelayPaymentPeriod.paymentPeriods } })
        }

        return (
            <>
                {this.props.resources.PmCompensationWarningBanner && (
                    <Alert variant="warning" >
                        <p>
                            {this.props.resources.PmCompensationWarningBanner}
                        </p>
                    </Alert>
                )}
                <BiDynamicForm
                    item={this.props.notification}
                    config={editorFormConfig}
                    valueChangeHandler={this.props.fieldChanged}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                />
            </>
        );
    }

    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType, this.props.notification.instructiontoquoteid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }



    render() {
        const documentIsFinal = this.props.notification.showtasknotification === 1;
        const { createby, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={createby}
                    createdate={createdate}
                    lastdraftedbyname={lastdraftedbyname}
                    lastdrafteddate={lastdrafteddate}
                    lastdraftednotifiedtoname={lastdraftednotifiedtoname}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(ItqDocument)));
